import type { ThreadSummary } from "../../../api/threads/threadDecoders";
import ItemReferenceName from "../../items/ItemReferenceName";
import ThreadSubjectLink from "../page/ThreadSubjectLink";
import { parseEditedItem } from "../prepare/author/editedItem";

/**
 * What a list line is filed under: the document a Thread works on, or the item an edit Thread
 * edits (ADR-0031 D2), a term's edit under its module. Nothing for a Thread with neither;
 * `className` places it in the line.
 */
export default function ThreadFiledUnder({ summary, className }: { summary: ThreadSummary; className?: string }) {
  const edited = summary.editedItem == null ? null : parseEditedItem(summary.editedItem);
  if (summary.subject == null && edited === null) return null;
  return (
    <span className={className}>
      {summary.subject != null ? (
        <ThreadSubjectLink subject={summary.subject} link={false} />
      ) : edited !== null ? (
        <span className="app-text-muted block truncate text-xs">
          <ItemReferenceName reference={edited.kind === "item" ? edited.reference : edited.module} link={false} showVersion={false} />
        </span>
      ) : null}
    </span>
  );
}
